module.exports = __webpack_public_path__ + "static/bg-sidebar-online-tools-4a8640fa9a365d2cf0144f529dfa5a28.svg";